export default __webpack_public_path__ + "static/media/product-6-min.ab98654b.jpg";